export default "__VITE_ASSET__CALU$tA9__"